import { render, staticRenderFns } from "./FaqManagement.vue?vue&type=template&id=71b7ab61&scoped=true&"
import script from "./FaqManagement.vue?vue&type=script&lang=js&"
export * from "./FaqManagement.vue?vue&type=script&lang=js&"
import style0 from "./FaqManagement.vue?vue&type=style&index=0&id=71b7ab61&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b7ab61",
  null
  
)

export default component.exports